<template>
  <div class="step-three">
    <div v-if="eventType === 2" class="visit-form-content">
      <van-collapse v-model="activeNames">
        <van-collapse-item :title="$t('form.listingStatus')" name="1">
          <div v-for="brandItem in visitForm.sdShelfList" :key="brandItem.projectId" class="form-item">
            <div v-if="!eventId || (!!eventId && brandItem.productList.length > 0)" class="label square">
              <span>{{ brandItem.projectName }}</span>
            </div>
            <div class="brand-item" v-for="(subItem, subIndex) in brandItem.productList" :key="subIndex">
              <div class="product-status">
                <XuSelect v-model="subItem.productId" :disabled="isDisable || !!eventId" placeholder="Please select a product" :dataOptions="filteredOptions(brandItem, subItem.productId)" :fieldNames="{label: 'productName', value: 'id'}" />
                <img v-if="!subItem.currentDisable" src="@/assets/images/event_del.png" alt="" class="del-img" @click="handleDel(brandItem, subIndex)">
              </div>
              <div class="product-listing">
                <div class="listing-item">
                  <div class="listing-label">{{ $t('form.listingOrNot') }}</div>
                  <van-field class="custom-field custom-radio-field">
                    <template #input>
                      <van-radio-group v-model="subItem.isShelf" :disabled="isDisable || !!eventId" direction="horizontal">
                        <van-radio v-for="(subItem, subIndex) in listingList" :key="subIndex" :name="subItem.value">{{ subItem.label }}</van-radio>
                      </van-radio-group>
                    </template>
                  </van-field>
                </div>
              </div>
            </div>
            <div v-if="!eventId" class="add-more" @click="handleAdd('sdShelfList', brandItem)">+ {{ $t('button.addMoreProduct') }}</div>
          </div>
        </van-collapse-item>
        <van-collapse-item :title="$t('shared.psi')" name="2">
          <div class="top-title">
            <img class="ell-icon" src="@/assets/images/ell_icon.png" alt="">
            <div>{{ $t('form.weeklySalesInventoryBrforeEventPcs') }}</div>
          </div>
          <div class="form-item" v-for="(brandItem) in visitForm.projectSaleBeforeList" :key="brandItem.projectId">
            <div class="label square">
              <span>{{ brandItem.projectName }}</span>
            </div>
            <div class="brand-item">
              <div class="product-listing">
                <div class="listing-product">
                  <div class="quantity-item">
                    <div class="title">{{ $t('shared.salesPcsWeek') }}</div>
                    <div class="stepper-custom">
                      <div class="step-btn" @click="handleStep(-5, brandItem, 'sales')">-5</div>
                      <div class="step-btn" @click="handleStep(-1, brandItem, 'sales')">-</div>
                      <van-field class="step-value" :disabled="isDisable" v-model.number="brandItem.sales" type="digit" :border="false" />
                      <div class="step-btn" @click="handleStep(1, brandItem, 'sales')">+</div>
                      <div class="step-btn" @click="handleStep(5, brandItem, 'sales')">+5</div>
                    </div>
                  </div>
                  <div class="quantity-item">
                    <div class="title">{{ $t('shared.inventoryPcs') }}</div>
                    <div class="stepper-custom">
                      <div class="step-btn" @click="handleStep(-5, brandItem, 'inventory')">-5</div>
                      <div class="step-btn" @click="handleStep(-1, brandItem, 'inventory')">-</div>
                      <van-field class="step-value" :disabled="isDisable" v-model.number="brandItem.inventory" type="digit" :border="false" />
                      <div class="step-btn" @click="handleStep(1, brandItem, 'inventory')">+</div>
                      <div class="step-btn" @click="handleStep(5, brandItem, 'inventory')">+5</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
    <div v-else class="visit-form-content">
      <van-collapse v-model="activeNames">
        <van-collapse-item :title="$t('form.listingStatus')" name="1">
          <div class="form-item" v-for="(brandItem, brandIndex) in visitForm.eventShelfList" :key="brandIndex">
            <div class="label square" v-if="!eventId || (!!eventId && brandItem.productList.length > 0)">
              <span>{{ brandItem.projectName }}</span>
            </div>
            <div class="brand-item" v-for="(subItem, subIndex) in brandItem.productList" :key="subIndex">
              <div class="product-status">
                <XuSelect v-model="subItem.productId" :disabled="isDisable || subItem.currentDisable" :dataOptions="filteredOptions(brandItem, subItem.productId)" placeholder="Please select a product" :fieldNames="{label: 'productName', value: 'id'}" />
                <img v-if="!subItem.currentDisable" src="@/assets/images/event_del.png" alt="" class="del-img" @click="handleDel(brandItem, subIndex)">
              </div>
              <div class="product-listing">
                <div class="listing-item">
                  <div class="listing-label">{{ $t('form.listingOrNot') }}</div>
                  <van-field class="custom-field custom-radio-field">
                    <template #input>
                      <van-radio-group v-model="subItem.isShelf" :disabled="isDisable || !!eventId" direction="horizontal">
                        <van-radio v-for="(subItem, subIndex) in popupListingList" :key="subIndex" :name="subItem.value">{{ subItem.label }}</van-radio>
                      </van-radio-group>
                    </template>
                  </van-field>
                </div>
                <div v-if="subItem.isShelf === 1">
                  <div class="listing-title">{{ $t('form.wayOfList') }}：</div>
                  <div class="listing-product" v-for="(checkItem, checkIndex) in subItem.detailList" :key="checkIndex">
                    <div class="checkout-custom">
                      <van-checkbox v-model="checkItem.isChoose" :disabled="isDisable || !!eventId" shape="square">{{ checkItem.type }}</van-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!eventId" class="add-more" @click="handleAdd('eventShelfList', brandItem)">+ {{ $t('button.addMoreProduct') }}</div>
          </div>
        </van-collapse-item>
        <van-collapse-item :title="$t('shared.psi')" name="2">
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.totalOpenSystemsSales') }}</span>
              <img class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
            </div>
            <van-field v-model="formThreeData.totalOpenSale" :disabled="isDisable" placeholder="" :border="false" type="digit" class="custom-field" />
          </div>
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.totalDisposableSales') }}</span>
              <img class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
            </div>
            <van-field v-model="formThreeData.totalDisposableSale" :disabled="isDisable" placeholder="" :border="false" type="digit" class="custom-field" />
          </div>
          <div class="form-item" v-for="subItem in visitForm.projectSaleBeforeList" :key="subItem.id">
            <div class="label">
              <span>{{ subItem.projectName }} {{ $t('form.salesPcsWeek') }}</span>
              <img class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
            </div>
            <van-field v-model="subItem.sales" :disabled="isDisable" placeholder="" :border="false" type="digit" class="custom-field" />
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant'
import { mapState } from 'vuex'
export default {
  props: {
    isDisable: {
      type: Boolean,
      default: false
    },
    eventType: {
      type: [String, Number],
      default: ''
    },
    eventId: {
      type: String,
      default: ''
    }
  },
  components: {
    XuSelect: () => import('@/components/XuSelect')
  },
  data () {
    return {
      activeNames: ['1', '2'],
      formThreeData: {
        totalOpenSale: '',
        totalDisposableSale: ''
      },
      visitForm: {
        sdShelfList: [],
        projectSaleBeforeList: [],
        eventShelfList: []
      },
      listingList: [
        { label: this.$t('form.listing'), value: 1 },
        { label: this.$t('form.notListing'), value: 0 }
      ],
      popupListingList: [
        { label: this.$t('form.listing'), value: 1 },
        { label: this.$t('form.notListing'), value: 0 },
        { label: this.$t('form.endOfSales'), value: -1 }
      ]
    }
  },
  computed: {
    ...mapState({
      globalData: 'globalData'
    }),
    filteredOptions () {
      return (brandItem, currentId) => {
        if (!this.globalData.productList || !brandItem.productList) return []
        const projectId = brandItem.projectId
        const selectedIds = brandItem.productList.map(item => item.productId).filter(id => id && id !== currentId)
        return this.globalData.productList.filter(item => !selectedIds.includes(item.id) && item.projectId === projectId)
      }
    }
  },
  methods: {
    editEcho (data) {
      if (!data) return
      if (this.eventType === 2) {
        data.sdShelfList.forEach(brandItem => {
          brandItem.productList.forEach(subItem => {
            subItem.currentDisable = true
          })
        })
        this.visitForm.sdShelfList = data.sdShelfList || []
        this.visitForm.projectSaleBeforeList = data.projectSaleBeforeList.map(subItem => {
          return { projectName: subItem.projectName, projectId: subItem.projectId, sales: subItem.sales || '', inventory: subItem.inventory || '' }
        })
      } else {
        data.eventShelfList.forEach(brandItem => {
          brandItem.productList.forEach(subItem => {
            subItem.currentDisable = true
          })
        })
        this.visitForm.eventShelfList = data.eventShelfList
        this.visitForm.projectSaleBeforeList = data.projectSaleBeforeList
        Object.keys(this.formThreeData).forEach(subItem => {
          this.formThreeData[subItem] = data.popup[subItem] || ''
        })
      }
    },
    handleTips () {
      Dialog.alert({
        message: this.$t('tips.messageEight'),
        confirmButtonText: this.$t('button.gotIt'),
        confirmButtonColor: '#307bff'
      }).then(() => {
        // on close
      })
    },
    // 校验
    checkVerify () {
      let isFlag = true
      return isFlag
    },
    handleDel (params, index) {
      if (this.isDisable) {
        return
      }
      Dialog.confirm({
        message: this.$t('tips.messageNine'),
        confirmButtonText: this.$t('button.confirm'),
        cancelButtonText: this.$t('button.cancel'),
        confirmButtonColor: '#c4200b'
      })
        .then(() => {
          params.productList.splice(index, 1)
        })
        .catch(() => {
          // on cancel
        })
    },
    handleAdd (type, params = {}) {
      if (this.isDisable) {
        return
      }
      if (params.productList.length >= this.globalData.productList.filter(item => item.projectId === params.projectId).length) {
        Toast(this.$t('tips.noMoreProducts'))
        return
      }
      if (type === 'sdShelfList') {
        params.productList.push({
          productId: '',
          isShelf: ''
        })
      } else if (type === 'projectSaleBeforeList') {
        params.push({
          sales: '',
          inventory: ''
        })
      } else if (type === 'eventShelfList') {
        params.productList.push({
          productId: '',
          isShelf: '',
          detailList: this.globalData.shelfType.map(subItem => { return { type: subItem.value, isChoose: false } })
        })
      }
    },
    handleStep (delta, params, typeKey, obj = {}) {
      if (this.isDisable) {
        return
      }
      if (obj.checkInventory) {
        let newQuantity = (Number(params[typeKey]) || 0) + delta
        if (newQuantity < 0) {
          newQuantity = 0
        }
        const newInventory = params.originalInventoryCount - newQuantity
        this.$set(params, typeKey, newQuantity)
        this.$set(params, 'inventoryCount', newInventory)
      } else {
        let newQuantity = (Number(params[typeKey]) || 0) + delta
        if (newQuantity < 0) {
          newQuantity = 0
        }
        this.$set(params, typeKey, newQuantity)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.step-three {
  .visit-form-content {
    /deep/.van-collapse {
      .van-collapse-item {
        background-color: #fff;
        .van-collapse-item__title {
          background-color: #e8effc;
          font-weight: bold;
          padding: 5px 10px;
          margin-bottom: 2px;
          .van-cell__title {
            font-weight: bold;
            > span {
              font-size: 14px;
            }
          }
        }
        .van-collapse-item__content {
          padding: 0px 10px;
          padding-top: 10px;
        }
      }
      &::after {
        border: none;
      }
    }
    .top-title {
      display: flex;
      font-weight: bold;
      color: #000;
      font-size: 12px;
      margin-bottom: 10px;
      .ell-icon {
        margin-top: 2px;
        width: 11px;
        height: 11px;
        margin-right: 5px;
      }
    }
    .form-item {
      margin-bottom: 20px;
      .label {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #333;
        margin-bottom: 8px;
        // 添加必填标记样式
        &.required {
          position: relative;
          padding-left: 12px; // 为星号预留空间
          &::before {
            content: '*';
            color: #ff4444;
            position: absolute;
            left: 0;
            top: 0;
            font-size: 14px;
            line-height: 1;
          }
        }
        &.square {
          font-weight: bold;
          &::before {
            content: '';
            width: 8px;
            height: 8px;
            background-color: #307bff;
            transform: rotate(45deg);
            margin-right: 5px;
          }
        }
        .label-icon {
          width: 16px;
          height: 16px;
          margin-left: 3px;
        }
      }
      .custom-field {
        padding: 5px 10px;
        background: #fff;
        border: 1px solid #b9cbed;
        border-radius: 4px;
        font-size: 12px;
        &::placeholder {
          color: #999;
        }
      }
      .custom-radio-field {
        padding: 0;
        font-size: 12px;
        border: none;
      }
      .del-img {
        width: 20px;
        height: 20px;
        margin-left: 5px;
      }
      .brand-item {
        font-size: 12px;
        margin-bottom: 10px;
      }
      .product-status {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .product-listing {
        padding: 10px;
        margin-top: 10px;
        background-color: #f7f7f7;
        border-radius: 10px;
        .listing-item {
          // display: flex;
          // align-items: center;
          // justify-content: space-between;
          padding-bottom: 5px;
          margin-bottom: 5px;
          .listing-label {
            margin-bottom: 5px;
            font-size: 12px;
            color: #333;
          }
          /deep/.van-cell {
            width: auto;
          }
          .custom-radio-field {
            background-color: #f7f7f7;
          }
        }
        .listing-title {
          margin-top: 10px;
          font-size: 13px;
          color: #7f7f7f;
        }
        .listing-product {
          .checkout-custom {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 10px;
            font-size: 12px;
            color: #7f7f7f;
            /deep/.van-checkbox__label {
              color: #7f7f7f;
            }
            .total-pcs {
              color: #307bff;
            }
          }
          .quantity-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 12px;
            margin-bottom: 5px;
            .title {
              width: 186px;
              &::before {
                content: '#';
                width: 8px;
                height: 8px;
                color: #307bff;
                margin-right: 5px;
              }
            }
          }
          /deep/.van-checkbox {
            .van-checkbox__label {
              margin-left: 3px;
            }
            .van-checkbox__icon {
              height: auto;
            }
          }
        }
      }
      .stepper-custom {
        display: flex;
        align-items: center;
        border: 1px solid #b9cbed;
        border-radius: 4px;
        overflow: hidden;
        .step-btn {
          width: 28px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #fff;
          color: #333333;
          cursor: pointer;
          border-right: 1px solid #b9cbed;;
          font-size: 12px;
          &:last-child {
            border-right: none;
          }
          &:active {
            background-color: #f2f3f5;
          }
        }
        .step-value {
          width: 32px;
          height: 24px;
          padding: 0;
          background-color: #fff;
          border-right: 1px solid #b9cbed;
          border-radius: 0;
          /deep/ .van-field__control {
            text-align: center;
            height: 24px;
            line-height: 24px;
            color: #323233;
            font-size: 12px;
          }
        }
      }
      /deep/.van-uploader {
        .van-uploader__upload {
          width: 60px;
          height: 60px;
        }
        .van-uploader__preview-image {
          width: 60px;
          height: 60px;
        }
      }
    }
    .add-more {
      display: inline-block;
      padding: 5px;
      font-size: 12px;
      color: #307bff;
      border: 1px solid #307bff;
      background-color: #e4eefc;
      border-radius: 6px;
    }
  }
  .info {
    margin-bottom: 20px;
    .item-title {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: bold;
      color: #307bff;
      margin-bottom: 10px;
      &::before {
        content: '';
        width: 6px;
        height: 12px;
        margin-right: 3px;
        background-color: #307bff;
      }
    }
    .form-item {
      padding: 0 10px;
      margin-bottom: 13px;
      .label {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #333;
        margin-bottom: 8px;
        // 添加必填标记样式
        &.required {
          position: relative;
          padding-left: 12px; // 为星号预留空间
          &::before {
            content: '*';
            color: #ff4444;
            position: absolute;
            left: 0;
            top: 0;
            font-size: 14px;
            line-height: 1;
          }
        }
        .label-icon {
          width: 16px;
          height: 16px;
          margin-left: 3px;
        }
      }
      .custom-field {
        padding: 5px 10px;
        background: #fff;
        border: 1px solid #b9cbed;
        border-radius: 4px;
        font-size: 12px;
        &::placeholder {
          color: #999;
        }
      }
      .custom-radio-field {
        padding: 0;
        font-size: 12px;
        border: none;
      }
    }
  }
}
/deep/.van-field--disabled {
  background-color: #ebedf0 !important;
}
</style>
